Vue.component('panel-repository', {
	props: ["options", "labellang"],
	template:
    '<transition v-if="isActive" name="bounce" enter-active-class="bounceInLeft" leave-active-class="bounceOutRight" v-bind:css="options.internal.isAnimationCompatibility">'+
    '<div class="bkgTransparent70">'+
    '<div id="panel-repository">'+
            '<div class="overlay-content" style="height:320px">'+
                '<button @click.prevent="closeView" class="pull-right"  ><i class="material-icons">cancel</i></button>' +
                '<p class="panel-repo-title">{{ title }}</p>'+
                '<div class="panel-repo-item" v-for="item in repositoryItems" @click="openUrl(item)">'+
                '<div class="row"><div class="col-xs-2"><i class="material-icons" v-if="item.tpl == \'link\'">link</i><i class="material-icons" v-if="item.tpl == \'document\'">insert_drive_file</i></div><div class="col-xs-10 repo-item-title"><span v-if="item.tpl == \'link\'">{{ labellang.repo_link }} </span><span v-if="item.tpl == \'document\'">{{ labellang.repo_document }} </span><span v-if="item.source == \'inbound\'">{{ labellang.repo_received }}</span><span v-if="item.source == \'outbound\'">{{ labellang.repo_sent }}</span> <i class="material-icons repo-outbound" v-if="item.source == \'outbound\'">call_made</i><i class="material-icons repo-inbound" v-if="item.source == \'inbound\'">call_received</i></div></div>'+
                '<div class="row"><div class="col-xs-2">&nbsp;</div><div class="col-xs-7 repo-item-name" >{{item.name}}</div><div class="col-xs-2 repo-item-time">{{item.time}}</div></div>'+
                '</div>'+
            '</div>'+
			'<div class="overlay-footer" v-if="sendFooter">' +
				//div tabs opener
				'<div class="tabsOpener">'+
				'<button @click="openDoc" class="tab btn" v-bind:class="{ active: doc }"><i class="material-icons">insert_drive_file</i></button>'+
				'<button @click="openLink" class="tab btn" v-bind:class="{ active: link }"><i class="material-icons">link</i></button>'+
				'</div>'+
				//end tabs opener
				// upload file
				'<div id="sendFilePanel" v-if="doc">'+
                '<form id="fileChooserForm" style="text-align:left">' +
					'<span style="font-weight:500">{{ this.titleSelectFile }}</span>' +
					'<div class="upload-btn-wrapper">'+
					'<button class="btnUpload"><i class="material-icons">add_circle_outline</i>{{ this.labellang.repo_choose_file }}</button>'+
                    '<input type="file" id="fileChooser" @change="onChangeInput"  name="file" style="line-height:1px;margin-top:5px;width:230px">' +
					'</div>'+
					'<p style="font-size:12px;color:green;" :class="{ \'error-msg\': textError }">{{ this.messageUpload }}</p>' +
					'<button @click.prevent="closeView" class="btn panelDocFile pull-left "  >{{ this.labellang.cancel }}</button>' +
					'<button @click.prevent="sendFile" class="btn panelDocFile btn-info pull-right " :disabled="isSendDisable" style="right:15px;">{{ this.labellang.send }}</button>' +
				'</form>' +
				'</div>'+
				// end upload file
				// send link
				'<div id="sendLinkPanel" v-if="link">'+
				'<form id="linkForm" style="text-align:left">' +
					'<span style="font-weight:500">{{ this.titleSendUrl }}</span>' +
					'<input :class="{ \'error-msg\': linkError }" v-model="inputLink" @blur="hasLink(inputLink)" type="text" id="linkSender" name="url"  placeholder="https://..."><i v-show="!linkError" style="color:green;margin-left:5px;" class="material-icons">check</i>'+
					'<p v-if="linkError" class="error-msg">{{ this.labellang.linkError }}</p>' +
					'<button @click.prevent="closeView" class="btn panelDocFile pull-left "  style="left:45px">{{ this.labellang.cancel }}</button>' +
					'<button @click.prevent="sendLink" class="btn panelDocFile btn-info pull-right " :disabled="isUrlDisable" style="right:15px;">{{ this.labellang.send }}</button>' +
				'</form>'+
				'</div>'+
				// end send link
		    '</div>' +
	'</div>'+
    '</div>'+
    '</div>'+
	'</transition>',
	data:function(){
		return {
			isActive:false,
            title: this.labellang.title_panel_repository,
            repositoryItems: [],
			titleSelectFile: this.labellang.selectFile,
			titleSendUrl: this.labellang.sendUrl,
			uploadError: null,
			messageUpload: '',
			isSendDisable: true,
			isUrlDisable: true,
			textError: false,
			doc: true,
			link: false,
			inputLink: '',
			linkError: false,
			sendFooter: true

		}
	},
	mounted: function() {
		var that = this;
		bus.$on('onOpenRepo', function (val) {
			that.contentShow(val);
        });
        bus.$on('addRepoItem', function(repo) {
            that.addItemRepo(repo);
        });
    //    bus.$on('onShareDoc', function (val) {
	//		that.contentShow(val);
	//	})
	//	this.$parent.$on('onShareDoc', function (val) {
	//		that.contentShow(val);
	//	})
		this.$parent.$on('onMaxSizeFile', function () {
			that.maxFileSize();
		})

		this.$parent.$on("onPause", function () {
			that.setFooter(false);
		});
		this.$parent.$on("onResume", function () {
			that.setFooter(true);
		});

	},
	methods:{
		setFooter:function(val) {
			this.sendFooter = val
		},
		contentShow:function(val){
            this.isActive = val;
            setTimeout(function(){
				new PerfectScrollbar(".overlay-content");
			 }, 100);
        },
		closeView: function () {
			this.isActive = false;
			this.messageUpload = "";
			this.isSendDisable = true;
			this.inputLink = "",
			this.linkError = false;
        },
        addItemRepo: function(repo) {
            this.repositoryItems = repo;
        },
        openUrl: function(item) {
            if (item.url) {
            window.open(item.url,'_blank');
            }
		},
		openDoc: function() {
			this.link = false;
			this.doc = true;
		},
		openLink: function() {
			this.link = true;
			this.doc = false;
		},
        noFileSelected: function () {
			return this.labellang.noFileSelected
        },
        sendFile: function () {
			this.options.internal.bridge.sendFile('fileChooser');
			this.messageUpload = '';
			this.isActive = false;

			setTimeout(function () {
				bus.$emit('onUpdateScroll');
				bus.$emit('showBackButton', false);
			}, 300);

		},
		sendLink: function() {
			var that = this;
			var timeout = null;
			clearTimeout(timeout);
			timeout = setTimeout(function(){
			  if (that.inputLink.length != 0) {
				var msg = that.inputLink;
				bus.$emit("newMessage", msg);
				that.inputLink = '';
				that.closeView();
			  }
			},500);


		  },
		maxFileSize: function () {
			this.messageUpload = this.labellang.documentSizeExceeded;
			this.isSendDisable = false;
		},
		validateFile: function (fileExt) {
			var fileTypes = this.options.internal.notAllowedExtensions;
			for (var i = 0; i < fileTypes.length; i++) {
				if (fileExt === fileTypes[i]) {
					return false;
				}
			}
			//se non è ne nelle unsupported extension controllo se ci sono delle supported extension da controllare
			if(this.options.internal.allowedExtensions){
				console.log(this.options.internal.allowedExtensions, fileExt);
				if(this.options.internal.allowedExtensions.indexOf(fileExt) >= 0){
					return true;
				}else{
					return false;
				}
			}
			return true;
		},
		returnFileSize: function (number) {
			if (number < 1024) {
				return number + 'bytes';
			} else if (number > 1024 && number < 1048576) {
				return (number / 1024).toFixed(1) + 'KB';
			} else if (number > 1048576) {
				return (number / 1048576).toFixed(1) + 'MB';
			}
		},
		onChangeInput: function (e) {
			var files = e.target.files || e.dataTransfer.files;

			if (!files.length) {
				return;
			}
			var haveExt = files[0].name.split('.');

			if (haveExt.length <= 1) {
				this.isSendDisable = true;
				this.messageUpload = this.labellang.no_extension;
				this.textError = true;
				return;
			}


			for (var i = 0; i < files.length; i++) {
				var ext = files[i].name.split('.').pop().toLowerCase();

				if (files[i].size > 0) {
					if (this.validateFile(ext)) {
						this.isSendDisable = false;
						var textContent = 'File name ' + files[i].name + ', file size ' + this.returnFileSize(files[i].size) + '.';
						this.messageUpload = textContent;
						this.textError = false
					} else {
						this.messageUpload = this.labellang.extensionError;
						this.textError = true

					}
				} else {
					this.isSendDisable = true;
					this.messageUpload = this.labellang.emptyFile;
					this.textError = true;

				}


			}
		},
		hasLink: function (inputLink) {
			var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
				'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
				'((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
				'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
				'(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
				'(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
			if (!pattern.test(inputLink)) {
				console.log('url errato')
				this.linkError = true;
				this.isUrlDisable = true;
			} else {
				console.log('url esatto')
				this.linkError = false;
				this.isUrlDisable = false;
			}
		},
	}
})
